import { toast } from "@replohq/lattice/components/toast/Toast";

// Stripe discards an unpaid pending subscription update after 23 hours.
const STRIPE_PENDING_UPDATE_TTL_MS = 23 * 60 * 60 * 1000;

/** Stripe holds the plan change until the customer approves the charge on Stripe's invoice page. */
export function showBankApprovalToast({
  url,
  onReturn,
}: {
  url: string;
  onReturn: () => void;
}) {
  toast.info({
    title: "Approve the payment with your bank",
    description:
      "Your plan changes once it's approved. Nothing changes until then.",
    duration: Infinity,
    action: {
      label: "Approve payment",
      onClick: () => {
        // Opened from the click so browsers don't block the new tab.
        window.open(url, "_blank", "noopener");
        // Refresh on every return, not just the first: the customer may look back before approving.
        window.addEventListener("focus", onReturn);
        window.setTimeout(() => {
          window.removeEventListener("focus", onReturn);
        }, STRIPE_PENDING_UPDATE_TTL_MS);
      },
    },
  });
}
